import { forwardRef, type Ref, useCallback } from 'react'

import { type z } from 'zod'

import { FormSubmitProvider, type FormSubmitProviderProps } from './FormSubmitProvider'
import { ZodForm, type ZodFormProps } from './ZodForm'

export interface ZodFormProviderProps<Z extends z.ZodTypeAny>
  extends ZodFormProps<Z>, FormSubmitProviderProps<z.infer<Z>> {}

export const ZodFormSubmitProvider = forwardRef(
  <Z extends z.ZodTypeAny>(
    { schema, defaultValues, values, disabled, children, onFormSubmit, ...props }: ZodFormProviderProps<Z>,
    ref: Ref<HTMLFormElement>
  ) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    const formSubmit = useCallback((data: z.infer<Z>) => onFormSubmit(schema.parse(data)), [onFormSubmit, schema])

    return (
      <ZodForm<Z> schema={schema} defaultValues={defaultValues} values={values} disabled={disabled}>
        <FormSubmitProvider {...props} onFormSubmit={formSubmit} ref={ref}>
          {children}
        </FormSubmitProvider>
      </ZodForm>
    )
  }
)
